import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {TweenLite} from 'gsap';
import {BarbarianFuryGameMode} from "../../gamemode/BarbarianFuryGameMode";
import {BarbarianFurySoundConfig} from '../../BarbarianFurySoundConfig';
import {BarbarianFuryParsedGameData} from "../../server/data/BarbarianFuryParsedGameData";
import {BarbarianFuryGameModuleConfig} from "../../BarbarianFuryGameModuleConfig";

export class BFFreespinOutroController extends FreespinOutroController {
    protected calculateIsTriggered(data:BarbarianFuryParsedGameData):boolean {
        let isTriggered = ((data.mode === BarbarianFuryGameMode.FREESPIN || data.mode === BarbarianFuryGameMode.STACKED_RESPIN_FREESPIN) && data.freespinsLeft === 0) && data.nextMode === BarbarianFuryGameMode.NORMAL;
        return isTriggered;
    }

    public start():void {
        const data: BarbarianFuryParsedGameData = (this._serverData as BarbarianFuryParsedGameData),
            delay: number = (data.singleWin > 0) ? 1 : 0.5;
        TweenLite.delayedCall(delay,
            () => {
                // #315
                if (!BarbarianFuryGameModuleConfig.featurePrice.isWinBelowStake()) {
                    SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.FS_END_SOUND);
                }
                super.start();
            });
    }
}